module.exports = __webpack_public_path__ + "static/media/mini.b3a2c02c.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/data/carImages/远程E200S平板车/mini.png
// module id = 723
// module chunks = 0